import React from "react";

import {
  customStyles,
  StyledSelect,
  IndicatorsContainer,
  StyledOption,
  StyledCheckbox,
} from "./styledSimsFilterComponent";

const SimsFilterComponent = (props) => {
  const { components, ...setting } = props;
  return (
    <StyledSelect
      className="text-muted mb-3"
      components={{ IndicatorsContainer, ...components }}
      styles={customStyles}
      isRtl
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
      noOptionsMessage={() => "وجود ندارد. ☹️"}
      {...setting}
    />
  );
};

export const Option = (props) => {
  return (
    <StyledOption
      {...props}
      $optionType={props?.data?.type}
      className="text-muted"
      defaultChecked={props.isSelected}
    >
      <label>{props.label}</label>
      <StyledCheckbox checked={props.isSelected}>
        <input type="checkbox" />
      </StyledCheckbox>
    </StyledOption>
  );
};

export default SimsFilterComponent;
